import { HttpMethod } from '@ori/checkout-utils';
import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function updateOfferItemsHandler({
  detail: {
    choiceId,
    items,
    placement
  }
}) {
  const response = await fetch(RequestUrl.UpdateOfferItems, getHttpRequestSettings({
    choiceId,
    items,
    placement
  }, HttpMethod.Post));
  return convertToCamelCase(await response.json());
}
//# sourceMappingURL=updateOfferItemsHandler.js.map